$(document).ready(function () {


//-------------------Take to shooping cart----------------------//
    $('.btn:not(.cta)').on('click', function (event) {
        $('html, body').animate({
        scrollTop: $(".cart").offset().top 
        }, 1000);

    });
//------------------ End Take to Shooping Cart------------------//

//-------------------Shooping Cart------------------------------//

    const subscribWrap = $('.subscribWrap'),
          cartCta = $('.cart .cta'),
          body = $('body'),
          choosePrices =$('.choosePrices')
          ;

    //subscribe box
      $('.subscribeBox').on("click", function(){
          $(this).find('.checkbox').toggleClass('checked');
          // cartCta.toggleClass('disabled');
      })

      //on touch screens
     if ("ontouchstart" in document.documentElement){
         body.addClass('touch');
        
         //exit btn
         $('.subscribWrap #exit').on('click', function(){
           subscribWrap.addClass('hide').removeClass('show');
        });
     }

    //activate subscribe prices
    $('.choosePrices > div:not(.subscribWrap)').on('click',function(){
        let thisBtn = $(this);
        $('.choosePrices div').removeClass('active');
        thisBtn.addClass('active');
        
        if(thisBtn.hasClass('subscribe')){
          choosePrices.attr('data-subscribe','subscribe');  
          // cartCta.addClass('disabled');

          //on touch screens
          if ("ontouchstart" in document.documentElement){
           subscribWrap.removeClass('hide').addClass('show');
          }
          
        }else{ 
          resetSubscribe();
        }
        $('.products .product.active').trigger( "click" );  
    });
    
   
 
    function resetSubscribe(){
      choosePrices.attr('data-subscribe','')
      $('.subscribWrap').removeClass('show').addClass('hide');
      // cartCta.removeClass('disabled');
      $('.subscribeBox .checkbox').removeClass('checked');
    }

    //set prices   
      function activeProduct() {
        let thisProduct = $(this);       
        let subscribe = $('.choosePrices').attr('data-subscribe');

       let price, link, ship;
        if(subscribe === 'subscribe'){
            price =  'data-subscribe-price';
            link = 'data-subscribe-link';
            ship = 'data-subscribe-shipping';
        }else {
            price =  'data-price' ;
            link = 'data-link';
            ship = 'data-shipping';
        }
      
          $('.cart .products .product').removeClass('active');
          thisProduct.addClass('active');  

          if(thisProduct.attr('data-amount') === "6" && subscribe === 'subscribe' ){
            $('.summary .perJar .value').html(parseFloat(
              (thisProduct.attr(price))/(thisProduct.attr('data-amount')) + 0.01
           ).toFixed(2));
          }else {
            $('.summary .perJar .value').html(parseFloat(
              (thisProduct.attr(price))/(thisProduct.attr('data-amount'))
           ).toFixed(2));
          }
          
        $('.summary .current .value').html(thisProduct.attr(price));
        $('.summary .retailPrice .value').html(thisProduct.attr('data-retail'));
        $('.summary .shipping .value').html( thisProduct.attr(ship));
          $('.cart .productImage img').removeClass('show').addClass('hide');
          $('.cart .productImage .'+ thisProduct.attr('data-amount') + "" ).addClass('show');  

          let param =  $('.cta').attr('data-param');
          $('.cta').attr('href',thisProduct.attr(link) + param );                                                      
        };
    
    $('.products .product').on('click', activeProduct);
    // $('.products .product').on('click', setLinks);
    $('.products .product.active').trigger( "click" );  
//------------------ End Shooping Cart-------------------------//
        
//-------------------Formula-----------------------------------//
	$('.formula .blends').slick({
    mobileFirst: true,
    variableWidth: false,
    slidesToShow: 1,
    dots:true,
    arrows: false,
    speed: 300,
    centerMode: false,    
    slidesToShow: 1,
    initialSlide : 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          infinite: false,
          slidesToShow: 3,
          dots:false
        }   
       
      }
    ]
	});
//------------------ End formula-------------------------------//

//-------------------Image Touch Slider------------------------//
	$('.imageTouchSlider .slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    dots: true,
    autoplay: true,
    arrows: true,
    prevArrow: '<a class="slick-prev" href="#"><i class="fa fa-angle-left"></i></a>',
    nextArrow: '<a class="slick-next" href="#"><i class="fa fa-angle-right"></i></a>',
    autoplaySpeed: 800,
    autoplaySpeed: 8000,
    pauseOnDotsHover: true,   
    appendDots:$(".imageTouchSlider .img"),
      customPaging: function(slick,index) {
                    var target = slick.$slides.eq(index).attr('data-location');;                      
                    return '<div class="dot '+ target + '"></div>';
                    }
	});
//------------------ End Image Touch Slider---------------------//

    
//-------------------How To Use-----------------------------------//

	$('.howToUse .steps.slider').slick({
    mobileFirst: true,
    variableWidth: false,
    dots:true,
    arrows: false,
    speed: 300,
    centerMode: false,    
    slidesToShow: 1,
    initialSlide :0,
    appendDots:$(".howToUse .steps.buttons"),
    customPaging: function(slick,index) {
      return '<h3> Step '+ (index + 1)+ '</h3>';
    },
    responsive: [
      {
        breakpoint: 991,
        settings: {
          infinite: false,
          slidesToShow: 3,
          dots:false
        }       
        // settings: 'unslick'       
      }
    ]
	});  

//------------------ End howToUse-------------------------------//

//-------------------Reviews-----------------------------------//
	$('.reviews .reviewList').slick({
    slidesToShow: 1,
		arrows: false,
		dots: true,
    speed: 700,
     autoplaySpeed: 800,
		adaptiveHeight: true,
    centerMode: false
	});  
//------------------ End Reviews-------------------------------//

    

});
